export type OwnProps = {
  error?: Error;
  componentStack?: string;
  statusCode?: number;
};

const ErrorBoundaryFallbackComponent = ({ statusCode }: OwnProps) => (
  <div className="min-h-[50vh] text-center">
    <p className="font-bold pt-48 text-4xl">Oops! {statusCode}</p>
    <p className="mt-8">There may have been a problem.</p>
    <p>We are sorry for the inconvenience.</p>

    <div>
      <img
        className="h-[118px] mx-auto my-56 w-[118px]"
        src="https://assets.fastly.carvana.io/merchui/images/error-sadcar-device.png"
        alt="Sad car"
      />
    </div>

    <a
      href="/cars"
      className="font-bold no-underline text-blue-2"
      data-analytics-id="Error Boundary - Back to Search"
    >
      Get back to SEARCH
    </a>
  </div>
);

export default ErrorBoundaryFallbackComponent;
